export const MOST_RECENT_FEDERAL_RESERVE_PROJECTION =
  "https://www.federalreserve.gov/monetarypolicy/files/fomcprojtabl20240320.pdf";
